import { render, staticRenderFns } from "./PlcButton.vue?vue&type=template&id=3ab230ee&scoped=true&"
import script from "./PlcButton.vue?vue&type=script&lang=js&"
export * from "./PlcButton.vue?vue&type=script&lang=js&"
import style0 from "./PlcButton.vue?vue&type=style&index=0&id=3ab230ee&scoped=true&lang=scss&"
import style1 from "./PlcButton.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab230ee",
  null
  
)

export default component.exports